import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  show: boolean = false;
  showMenu: boolean = false;
  showSubmenu: number = 0;
  constructor() {}

  ngOnInit() {
    // Update current year

    const getHamburgerIcon = () => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('width', '50');
      svg.setAttribute('height', '50');
      svg.setAttribute('viewBox', '0 0 16 16');
      const path = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path'
      );
      path.setAttribute('fillRule', 'evenodd');
      path.setAttribute(
        'd',
        'M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5'
      );
      svg.appendChild(path);
      return svg;
    };

    const getCloseIcon = () => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      svg.setAttribute('width', '50');
      svg.setAttribute('height', '50');
      svg.setAttribute('viewBox', '0 0 16 16');
      const path = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path'
      );
      path.setAttribute(
        'd',
        'M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708'
      );
      svg.appendChild(path);
      return svg;
    };

    // Hamburger menu
    const button: any = document.querySelector('.menu-show');
    const icon = button.querySelector('i');
    icon.addEventListener('click', () => {
      const menu = document.querySelector('.hamburger-menu');
      icon.textContent = '';
      if (menu.classList.contains('hidden')) {
        icon.appendChild(getCloseIcon());
        button.title = 'Close menu';
        menu.classList.remove('hidden');
      } else {
        icon.appendChild(getHamburgerIcon());
        button.title = 'Open menu';
        menu.classList.add('hidden');
      }
    });
  }
}
